const components = [
  {
    type: 'Body',
    slugName: '',
    components: [],
  },
];

export const formatSlug = (year, edition, pageNum) => `revista-${year}-ed-${edition}-pag-${pageNum}`;

const formatPageData = (postData, pageText, month, year, edition, pageNum) => {
  return {
    components: JSON.stringify(components),
    active: true,
    postCategory: ['magazine-page'],
    postDescription: {
      title: {
        en: `${month} ${year}. RDL ${edition}`,
        es: '',
        ca: '',
        pt: '',
      },
      subtitle: {
        en: `Página ${pageNum}`,
        es: '',
        ca: '',
        pt: '',
      },
      description: {
        en: pageText,
        es: '',
        ca: '',
        pt: '',
      },
      image: {
        en: postData.postDescription.image.en || '',
        es: '',
        ca: '',
        pt: '',
      },
      tags: postData.postDescription.tags,
      url: `${postData.postDescription.url}?pdfPage=${pageNum}`,
      date: postData.postDescription.date,
      expirationDate: null,
      launcherSortDate: null,
    },
    slugName: formatSlug(year, edition, pageNum),
    postName: formatSlug(year, edition, pageNum),
    type: 'route',
    rolesAllowed: ['rdl-subscription'],
    noIndex: false,
    requiresCompleteRegistration: false,
  };
};

export default formatPageData;
